import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService as CoreAuthService, FundService } from '@gs-2.0/core';

export const portalAdminFundGuard: CanActivateFn = async () => {
  const authService = inject(CoreAuthService);
  const fundService = inject(FundService);
  const router = inject(Router);

  if (!authService.hasRole('PORTAL_ADMIN')) {
    return true;
  }

  await fundService.loadFunds();

  if (fundService.funds().length === 0) {
    return router.createUrlTree(['/settings/fund-settings']);
  }

  return true;
};
